import { render, staticRenderFns } from "./industry-rich-editor.vue?vue&type=template&id=4e8c6218&"
import script from "./industry-rich-editor.vue?vue&type=script&lang=js&"
export * from "./industry-rich-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports